import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useEventSanctioned = () => {
  const [isSanctioned, setIsSanctioned] = useState(false);
  const { data: periodPenalties } = useSelector(
    (state: any) => state.eventPenalties
  );

  const { data: dataExternalSettings } = useSelector(
    (state: any) => state.externalSettings
  );

  useEffect(() => {
    if (periodPenalties && dataExternalSettings) {
      setIsSanctioned(
        periodPenalties.includes(dataExternalSettings.current_utp_period)
      );
    }
  }, [periodPenalties, dataExternalSettings]);

  return isSanctioned;
};

export default useEventSanctioned;
